import moment from 'moment'
import React, { useState, useEffect,useRef,useCallback } from 'react'
import { Attendance,FR } from '../../sdk'
import { Loader } from '../Default'
import { assetUrl } from '../../helpers'
import { DataTable2 } from '../Default/DataTables/DataTable2'
import { useAuthContext } from '../../context/Auth/Create'
import { DataTable } from '../Default/DataTables/DataTable'
import { SearchableSelectBox } from '../Default/SearchableSelectBox'
import { toasterFunction } from '../Default/ToasterComponent'

export const DateWiseSearch = () => {
  const userAuth=useAuthContext()
  
  const [state, setState] = useState({ loader: true,selectFilter:false,
    date: moment().subtract(1,"day").format("yyyy-MM-DD"),year:new Date().getFullYear(),month:Number(new Date().getMonth()),employeeId:"",tableLoader: false ,
    tbHeader:[
      {title:"Date",name:"date"},{title:"ID",name:"employeeId"},{title:"Name",name:"employeeName"},{title:"Company Name"},{title:"Department",name:"department"},{title:"CheckIn",},{title:"CheckOut"},{title:"image"},{title:"Operations"}
 
],
    tbHeader2:[{title:"ID",name:"employeeId",data:"employeeId"},{title:"Name",name:"employeeName",data:"employeeName"},{title:"Date",name:"date",data:"date"},{title:"CheckIn",data:"employeeId",render:function(data,type,row){
      return row.checkIn?row.checkIn:""
    }},{title:"CheckOut",name:"CheckOut",data:"employeeId",render:function(data,type,row){
      return row.checkOut?row.checkOut:""
    }},{title:"cameraId",name:"cameraId",data:"employeeId",render:function(data,type,row){
      return row.cameraId?row.cameraId:""
    }},{title:"Image",data:"employeeId", render: function (data, type, row) {
      return row.imageName && row.imageName !=""?`<a href=${assetUrl}${row.imageName} target='_blank'><img src=${assetUrl}${row.imageName} style="width:100%"; /></a>`:"mannual attendnce";
    },}],
  data:[],data2:[],tableLoader2:true,companyName:userAuth.user.isHightAuthority?userAuth?.user.companyName:"",
  department:"",
  companies:[],
  departments:[],
  employees:[],
  selectedData:{},
  selectEmployee:"",
  selectIndex:"",
  selectId:"",
  preSelectedEmployee:"",
  formAttr:{
    employee_id:"",
    check_in:"",
    date:"",
    type:"checkin",
  },
});
const onSelectInput=useCallback((event)=>{
  let selectEmployee=event.target.value;
  let id=event.target.getAttribute('data-id');
  ref4.current={...ref4.current,selectEmployee,selectId:id}
  setState((pre)=>{
    return {...pre,selectEmployee,selectId:id}
  })},[])
  const ref4=useRef({
    employeeId:"",
    date:moment().subtract(1,"day").format("yyyy-MM-DD"),
    companyName:userAuth.user.isHightAuthority?userAuth?.user.companyName:"",
    year:new Date().getFullYear(),
    month:Number(new Date().getMonth()),
    department:"",
    companies:[],
    departments:[],
    selectId:"",
    selectIndex:"",
    selectEmployee:"",
    preSelectedEmployee:"",
    data:[],
    dataTable1Params:{
      draw:1,
      start:0,
      length:0,
      search:"",
      order:"",
      columns:"",
      sort:"asc"
    },
    dataTable2Params:{
      draw:1,
      start:0,
      length:0,
      search:"",
      order:"",
      columns:"",
      sort:"asc"
    }

  });
  const onHandler = (event) => {
    let date = null;
    if(event.target.name == "date"){
      date = moment(event.target.value).format("yyyy-MM-DD");
      setState((pre)=>{
        return {...pre,[event.target.name]:date}
          })
    }else{
      setState((pre)=>{
        return {...pre,[event.target.name]:Number(event.target.value)}
          })
    }
      
    // apiData(moment(month).format("yyyy-MM-DD"))
    
    console.log(state);
  }
  function convertHoursToHHMM(seconds) {
    const duration = moment.duration(seconds, 'seconds');
      const formattedTime = `${Math.floor(duration.asHours()).toString().padStart(2, '0')}:${duration.minutes().toString().padStart(2, '0')}:${duration.seconds().toString().padStart(2, '0')}`;
      return formattedTime;
    }
    const apiDataWithPagination = async (data,callBack2,companyName=ref4.current.companyName,department=ref4.current.department,year=ref4.current.year,month=ref4.current.month,employeeId=ref4.current.employeeId,initialLoad=false) => {
      try {
        ref4.current={...ref4.current,dataTable2Params:{
          draw:data?.draw,
          start:data?.start,
          length:data?.length,
          search:data?.search?.value || "",
          order:data?.order,
          columns:data?.columns,
          sort:data?.sort
        },
        callBack2
        }
        if(!initialLoad){
return;
        }
       if(employeeId ===""){
        alert("please select employee id");
        return;
       }
       setState((pre)=>{
        return {...pre,tableLoader:true}
       })
        
          
        let apiData = {
          draw:data?.draw,
          start:data?.start,
          length:data?.length,
          search:data?.search?.value || "",
          order:data?.order,
          columns:data?.columns,
          sort:data?.sort,
          companyName,department,month,year,employeeId
          
                
        }
        let users=await  new Attendance().combinedData({...apiData});
        let arr=[];
        let count=0;
        if(users.length){
        for(let val of users){
          arr.push([
            val.date,
            val.employeeId,
            val.employeeName,
            val.companyName,
            val.department,
            val.checkIn?val.checkIn:"",
            val.checkOut?val.checkOut:"",
            val.image?`<div style="display: none;">${assetUrl}${val.image}</div><img  src=${assetUrl}${val.image} style="max-width:100px;max-height:100px" />`:"",
            val.tableType==="missingpeaples"?`<button type="button" data-emloyeeId=${val._id} data-index=${count} class="btn btn-theme details">Details</button> <button type="button"  data-emloyeeId=${val.employeeId} data-id=${val._id} class="btn btn-theme mark-attendance">Mark Attendance</button>`: ""
          ]
            )
           count++;
          }
         
        }
       
        setState((pre)=>{
          return {...pre,data:arr,tableLoader:false}
       })
     
      } catch (e) {
        console.log(e);
        alert("error occur")
      }
  
    }
  
  
  const apiData=async()=>{
    try{
    let users=await new FR().getCompanies();
    let departments=[]
		let find=users.find(val=>val.companyName===state.companyName);
			if(find){
			 departments=find.departments;
			}
		
		setState((pre)=>{
		  return {...pre,companies:users,loader:false,departments}
	   })
   }catch(e){
    console.log(e)
    alert("error occur")
    }

}
 const onHandlerType=async(event)=>{
          let key=event.target.name;
          let value=event.target.value;
          if(key==="companyName" || key==="department"){
          let departments=[];
          let employees=[];
          let department=state.department;

          if(key==="companyName"){
            if(value==="N/A"){
              setState((pre)=>{
               return {...pre,selectFilter:true} 
              })
              let getEmployees=await new FR().getAllData({status:1,department:value,companyName:value});
              employees=getEmployees.map(val=> {
                return {id:val.employeeId,name:`${val.firstName} ${val.middleName || ""} ${val.lastName || ""}`}
              });
              setState((pre)=>{
                return {...pre,selectFilter:false} 
               })
            }
            else{
              let find=state.companies.find(val=>val.companyName===value);
              if(find){
               departments=find.departments;
              }
              department=""
            }
           
          }
        
          if(key==="department"){
          if(value !==""){
            setState((pre)=>{
              return {...pre,selectFilter:true} 
             })
            let getEmployees=await new FR().getAllData({status:1,department:value,companyName:ref4.current.companyName});
            employees=getEmployees.map(val=> {
              return {id:val.employeeId,name:`${val.firstName} ${val.middleName || ""} ${val.lastName || ""}`}
            });
            setState((pre)=>{
              return {...pre,selectFilter:false} 
             })
            
          }  
         
          departments=state.departments;
          department=value;
          }
          ref4.current={...ref4.current,[key]:value,department:state.department,employeeId:"",department}
          setState((pre)=>{
            return{...pre,[key]:value,departments,employees,department}
          })
          }
          else{
           ref4.current={...ref4.current,[key]:value}
           setState((pre)=>{
             return{...pre,[key]:value}
           })
          }
  }
         const onSearchHandle=(value)=>{
          ref4.current.employeeId=value
          setState((pre)=>{
            return{...pre,employeeId:value}
          })
         }
         const onDetails=(id,selectIndex)=>{
          let check=state.rawData.find(val=>val._id===id);
          
          if(check){
            const maxObject = check.recognitions.reduce((max, obj) => obj.confidence > max.confidence ? obj : max, check.recognitions[0]);
            let selectEmployee=maxObject?.employee_id;
            let preSelectedEmployee=ref4.current.preSelectedEmployee;
            
            if(ref4.current.selectEmployee !== "" && (id ===ref4.current.selectId && selectEmployee !== preSelectedEmployee)){
              selectEmployee=ref4.current.preSelectedEmployee;
            }
            let selectId=id;
            ref4.current={...ref4.current,selectEmployee,preSelectedEmployee,selectId,selectIndex}
            setState((pre)=>{
              return {...pre,selectedData:check,selectEmployee,preSelectedEmployee,selectIndex,selectId}
            })
            window.$("#showImg").modal("show");
          }
          else{
            alert("data not found")
          }
          
          // apiData2(employeeId);
         
         
        }
      const onSelect=()=>{
        let val=state.rawData.find(val=>val._id===ref4.current.selectId);
        if(val){
         let maxObject=val.recognitions.find(val2=>val2.employee_id===ref4.current.selectEmployee);
         state.data[Number(ref4.current.selectIndex)]=[val.date,moment.unix(val.time/1000).format("HH:mm:ss"),maxObject?.employee_name?maxObject.employee_name:"",maxObject?.employee_id?maxObject.employee_id:"",val.type?val.type:"",maxObject?.confidence?maxObject.confidence:"",val.image?`<div style="display: none;">${assetUrl}${val.image}</div><img src=${assetUrl}${val.image} style="width:100%;height:140px" />`:"",`<button type="button" data-emloyeeId=${val._id} data-index=${ref4.current.selectIndex} class="btn btn-theme details">Details</button> <button type="button" data-emloyeeId=${maxObject?.employee_id?maxObject.employee_id:""} data-id=${val._id} class="btn btn-theme mark-attendance">Mark Attendance</button>`];
         ref4.current.data[Number(ref4.current.selectIndex)]=[val.date,moment.unix(val.time/1000).format("HH:mm:ss"),maxObject?.employee_name?maxObject.employee_name:"",maxObject?.employee_id?maxObject.employee_id:"",val.type?val.type:"",maxObject?.confidence?maxObject.confidence:"",val.image?`<div style="display: none;">${assetUrl}${val.image}</div><img src=${assetUrl}${val.image} style="width:100%;height:140px" />`:"",`<button type="button" data-emloyeeId=${val._id} data-index=${ref4.current.selectIndex} class="btn btn-theme details">Details</button> <button type="button" data-emloyeeId=${maxObject?.employee_id?maxObject.employee_id:""} data-id=${val._id} class="btn btn-theme mark-attendance">Mark Attendance</button>`] 
        }
        
        let preSelectedEmployee=ref4.current.selectEmployee;
        ref4.current={...ref4.current,preSelectedEmployee}
        setState((pre)=>{
          return {...pre,...state,preSelectedEmployee}
        })
        window.$("#showImg").modal("hide");
        }
      const onSelectSubmit=async (id,employeeId)=>{
        console.log("here")
        try{
         if(window.confirm("are you want to mark this attendance ? Please Make sure, beacuse this attendance can not be undo")){
          await new Attendance().markAttendance({id,employeeId:String(employeeId)});
          toasterFunction.success("attendance has been mark");
          window.location.reload(); 
         } 
      
        }catch(e){
      if(e.response.status===404){
        toasterFunction.error("check in not found")
      }
      else{
        toasterFunction.error("something went wrong");
      }
       
        }
        }
        useEffect(()=>{
          apiData();
          },[])
  if (!state.loader) {
    return (
      <>
        <div className="card mb-3">
          {/* BEGIN card-body */}
          <div className="card-body">
            <div className="d-flex fw-bold small mb-3 row" style={{textAlign:"center"}}>
              
              <div className="col-12">
                <span className="flex-grow-1">User Wise Report</span>
              </div>
              <div className="col-sm-12 col-md-3 col-lg-2">
      <div class="form-group mb-3" >
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect1" ></label>
        <select class="form-select" name="companyName" id="exampleFormControlSelect1" onChange={onHandlerType} style={{color:"rgb(60, 210, 165)"}}>
          <option value="" selected={ref4.current.companyName===""}>Company</option>
          {state.companies.map((val,index)=>{
            return  <option key={index} value={val.companyName} selected={ref4.current.companyName===val.companyName}>{val.companyName}</option>
          })}
         
          
          </select>
          </div>
       </div>
       <div className="col-sm-12 col-md-3 col-lg-2" >
      <div class="form-group mb-3" >
        <label class="form-label text-white fw-bold" for="exampleFormControlSelect2" ></label>
        <select class="form-select" name="department" id="exampleFormControlSelect2" onChange={onHandlerType} style={{color:"rgb(60, 210, 165)"}}>
        <option value="" selected={ref4.current.companyName===""}>Department</option>
          {state.departments.map((val,index)=>{
            return  <option key={index} value={val} selected={ref4.current.department===val}>{val}</option>
          })}
          </select>
          </div>
       </div>
       {state.selectFilter && <Loader/>}
       <div className="col-sm-12 col-md-3 col-lg-3">
      <div class="form-group mb-3" >
       
      <SearchableSelectBox data={state.employees} onSearchHandle={onSearchHandle} selected={ref4.current.employeeId}/>
     
          </div>
       </div>
       <div className="col sm-6 col-md-2">
                {/* <button type="button" class="btn btn-theme" onClick={exportCsv}>Export Csv</button> */}
                <div class="form-group mb-3" style={{ width: "85%" }}>
                  <label class="form-label" for="exampleFormControlSelect1"></label>
                  <input type="date" class="form-control" id='date' name='date' placeholder="dd/mm/yyyy" onChange={onHandler} value={state.date} style={{color:"rgb(60, 210, 165)"}}/>
                </div>
              </div>
       {/* <div className="col-sm-12 col-md-2 col-lg-2" >
                  <div class="form-group mb-3" >
                                            <label class="form-label" for="exampleFormControlSelect1" style={{color:'rgb(60, 210, 165)'}}></label>
                                            <select class="form-select" name="year" onChange={onHandlerType} style={{color:'rgb(60, 210, 165)'}}>
                                             {Array(Number(new Date().getFullYear()) - 2022).fill(2023).map((v,index)=>{
                                              return (<>
                                                  <option value={Number(v) + Number(index)} selected={Number(new Date().getFullYear()) ===Number(v) + Number(index)}>{Number(v) + Number(index)}</option>
                                                  
                                                  </>)
                                             })}
                                            </select>
                                          </div>
                  </div>
                  <div className="col-sm-12 col-md-2 col-lg-2" >
                  <div class="form-group mb-3" >
                                            <label class="form-label" for="exampleFormControlSelect1" style={{color:'rgb(60, 210, 165)'}}></label>
                                            <select class="form-select" name="month"  id="exampleFormControlSelect1" onChange={onHandlerType} style={{color:'rgb(60, 210, 165)'}}>
                                             {Array(12).fill(1).map((v,index)=>{
                                              return (<>
                                                  <option value={Number(v) + Number(index) - 1} selected={Number(new Date().getMonth()) ===index}>{months[index]}</option>
                                                  
                                                  </>)
                                             })}
                                            </select>
                                          </div>
                  </div> */}
             
              <div className='col-2'>
                <label class="form-label" for="Location"></label>
                <br />
                <button type="button" class="btn btn-theme" onClick={()=>apiDataWithPagination({...ref4.current.dataTable2Params},ref4.current.callBack2,ref4.current.companyName,ref4.current.department,ref4.current.year,ref4.current.month,ref4.current.employeeId,true)}>Search</button>
              </div>
            </div>

            {state.tableLoader && <><Loader/></>}
   
   <div className="col-12">
   {/* {<DataTable2 headers={state.tbHeader} image={true}  reverse={true} count={"paginationTable9"} ajax={apiDataWithPagination} onDetails={onDetails} isLoading={state.dataTableLoader}/>} */}
   <DataTable headers={state.tbHeader} data={state.data} image={true} updated={state.updated} onDetails={onDetails} onSelectSubmit={onSelectSubmit}/>
  
   </div>
          </div>
          <div className="card-arrow">
            <div className="card-arrow-top-left" />
            <div className="card-arrow-top-right" />
            <div className="card-arrow-bottom-left" />
            <div className="card-arrow-bottom-right" />
          </div>
        </div>
        {/* <div class="modal" id="showImg">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
            <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
  
              <div class="modal-body">
              {state.tableLoader2 && <Loader/>}
              {<DataTable2 headers={state.tbHeader2} data={state.data2} image={true}  reverse={true} count={"paginationTable10"} ajax={apiData2WithPagination} />}
              </div>

            </div>
          </div>
        </div> */}
 <div class="modal" id="showImg">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
            <div class="modal-header">
        
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
  
  <div class="modal-body">
    <div>
        <h5>Actual Information</h5>     
  <table className="table">
    <thead>
      <tr>
       
       <th scope="col">Date</th>
        <th scope="col">Time</th>
        <th scope="col">Image</th>
      </tr>
    </thead>
    <tbody>
      <tr>
       
        <td style={{width:"25%"}}>{state.selectedData.date}</td>
        <td style={{width:"25%"}}>{moment.unix(state.selectedData.time/1000).format("HH:mm:ss")}</td>
        <td style={{width:"25%"}}>
      {state.selectedData.image ? (
        <>
          <div style={{ display: 'none' }}>{`${assetUrl}${state.selectedData.image}`}</div>
          <img src={`${assetUrl}${state.selectedData.image}`} style={{ width: '50%', height: '100px' }} alt="Selected" />
        </>
      ) : (
        ""
      )}
    </td>
      </tr>
    </tbody>
  </table>

  </div>
  <hr/>
  <div>
  <h5>Employees with confidence</h5>     
  <table className="table">
    <thead>
      <tr>
        <th scope="col">#</th>
        <th scope="col">Name</th>
        <th scope="col">Employee Id</th>
        <th scope="col">Department</th>
        <th scope="col">Confidence</th>
        <th scope="col">Image</th>
      </tr>
    </thead>
    <tbody>
     {state.selectedData?.peoples?.map((val,index)=>{
      let {confidence}=state.selectedData.recognitions.find(val2=>val2.employee_id ===val.employeeId);
      
      return (<>
       <tr>
        <th scope="row"><div className="form-check">
  <input
    className="form-check-input"
    type="radio"
    value={val.employeeId}
    id={`defaultRadio${val.employeeId}`}
    onChange={onSelectInput}
    data-id={state.selectedData?._id}
    checked={val.employeeId===state.selectEmployee}
  />
  <label className="form-check-label" htmlFor={`defaultRadio${index}`} style={{display:"none"}}>
    Default checkbox
  </label>
</div></th>
        <td>{`${val.firstName} ${val.middleName} ${val.lastName}`}</td>
        <td>{val.employeeId}</td>
        <td>{val.departmentName}</td>
        <td>{Number(confidence).toFixed(2)}</td>
        <td>{val.frontImageUrl ? (
        <>
          <div style={{ display: 'none' }}>{`${assetUrl}${val.frontImageUrl}`}</div>
          <img src={`${assetUrl}${val.frontImageUrl}`} style={{ width: '50%', height: '100px' }} alt="Selected" />
        </>
      ) : (
        ""
      )}</td>
      </tr>
      
      </>)
     })}
     
     
    </tbody>
  </table>

  </div>
              </div>
              <div className="modal-footer">
  <button type="button" className="btn btn-default" data-bs-dismiss="modal">
    Close
  </button>
  <button type="button" className="btn btn-outline-theme" onClick={onSelect}>
    Select
  </button>
</div>
            </div>
          </div>
        </div>

      </>


    )
  }
  else {

    return (<>
      <Loader />
    </>)
  }

}
